import { Container } from "./style";
import TextFieldView from "../../components/commons/TextField.view";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../store";
import { useNavigate } from "react-router-dom";
import { UserApi } from "../../api/User.api";
import { setUser } from "../../store/modules/app";
import { Storage } from "../../utils/Storage";
import moment from "moment";
import { getAnalytics, logEvent, setUserProperties } from "firebase/analytics";
import { LogApi } from "../../api/Log.api";
import OrderSubscriptionView from "../../components/OrderSubscription.view";
import { Product } from "../../commons/Const";
import Error from "../../models/Error.model";
import { useQuery, useQueryClient } from "@tanstack/react-query";


export default function SubscriptionPage() {

  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const queryClient = useQueryClient();
  const {data: user} = useQuery({
    queryKey: ['user'],
    queryFn: UserApi.getMe,
  })


  const [product, setProduct] = useState<Product|null>(null)
  const [payMethod, setPayMethod] = useState(0)
  const [isPaying, setIsPaying] = useState(false)

  const [cardNo, setCardNo] = useState('')
  const [expireDate, setExpireDate] = useState('')
  const [cvc, setCvc] = useState('')
  const [pw, setPw] = useState('')

  useEffect(() => {

    if(user === undefined) return;

    if(user === null) navigate('/')

    if(user !== null && user.subscriptionList.length !== 0) {
      navigate('/')
    }
  }, [user])

  useEffect(() => {
    //order()
  }, [])

  const order = async () => {

    if(!user) return
    if(product === null) return;

    let amount = product.price + product.vat;

    if(process.env.REACT_APP_IS_TEST === 'true') {
      
      if(product.id === 3) {
        amount = (amount / 1000);
      }
      else {
        amount = (amount / 100);
      }
    }

    let paymentData: any = {};

    if(payMethod === 0) {
      paymentData = {
        pg: process.env.REACT_APP_PG_CARD,
        pay_method : 'card',
        merchant_uid : `${user.phone}-${new Date().getTime()}`,
        name : product.name,
        amount : amount,
        buyer_name : user.name,
        buyer_tel : user.phone,
        customer_uid: `sellerguard-stage-${user.phone}`,
        period : {
          from : moment().format('YYYYMMDD'), //YYYYMMDD
          to : moment().add(1, 'month').subtract(1, 'day').format('YYYYMMDD')
        }
      }
    }
    else if(payMethod === 1) {
      paymentData = {
        pg: process.env.REACT_APP_PG_PHONE,
        pay_method : 'phone',
        merchant_uid : `${user.phone}-${new Date().getTime()}`,
        name : product.name,
        amount : amount,
        buyer_name : user.name,
        buyer_tel : user.phone,
        customer_uid: `sellerguard-stage-${user.phone}`,
        period : {
          from : moment().format('YYYYMMDD'), //YYYYMMDD
          to : moment().add(1, 'month').subtract(1, 'day').format('YYYYMMDD')
        }
      }
    }

    try {

      setIsPaying(true);
      const paymentResult = await requestPayment(paymentData);

      await UserApi.startSubscription(product.id, payMethod, paymentResult)
      
      queryClient.invalidateQueries({queryKey: ['user']});
      getUser();
      navigate('/signup/success');

      const analytics = getAnalytics();
      setUserProperties(analytics, {
        id: user.id,
        name: user.name
      })
      logEvent(analytics, 'purchase')
  
    } catch (error) {
      console.log(error)
      if(error instanceof Error) {
        
      };
      LogApi.addLog(JSON.stringify(error));
    } finally {
      setIsPaying(false);
    }
    
  }

  const getUser = () => {
    UserApi.getMe()
    .then(result => {
      dispatch(setUser(result))
    }).catch(error => {

    })
  }

  const requestPayment = async (data: any): Promise<any> => {

    return new Promise((resolve, reject) => {
      const { IMP } = window
      IMP.init("imp84428497");

      IMP.request_pay(data, (response: any) => {
        if(response.success) {
          resolve(response);
        }
        else {
          reject(response);
        }
      });
    })
  }

  if(user === undefined || user === null || (user !== null && user.subscriptionList.length !== 0)) return <></>

  return (
    <Container>
      {isPaying && <div className="pg_overlay" />}
      <div className="inner">
        <p className="page_title"><span>법률자문 구독하기</span></p>

        <section>
          <OrderSubscriptionView 
            onChange={(product, payMethod) => {
              setProduct(product);
              setPayMethod(payMethod);
            }}
          />

          <button className="contained_main btn_done"
            onClick={order}
          >
            <strong className="fs16 ">결제하고 구독하기</strong>
          </button>
        </section>
      </div>
    </Container>
  )
}